<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="row">
      <h4 class="col-sm-6" qid="clients-members-page-title">
        {{ client.name }}
        {{ $t('administration.clients.members.title') }}
      </h4>
      <div class="float-right col-sm-6">
        <div class="row">
          <div class="col-sm-5">
            <div>
              <multiselect
                  v-model="selectedUser"
                  :options="options"
                  :placeholder="$t('administration.clients.members.select_user_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  @search-change="asyncFind"
                  qid="clients-members-user-dropdown"
              ></multiselect>
            </div>
          </div>
          <div class="col-sm-5">
            <multiselect
                v-model="selectedRole"
                :options="roles ? roles : []"
                :placeholder="$t('administration.clients.members.select_role_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="clients-members-role-dropdown"
            ></multiselect>
          </div>
          <div class="col-sm-2">
            <b-button variant="success"
                      qid="create-user-submit-button"
                      class="btn-block"
                      @click="addUser"
                      :disabled="selectedUser && selectedUser.length ? true : false"
            >
              {{ $t('administration.clients.members.add') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <table class="table table-responsive-md">
        <thead>
        <tr>
          <th scope="col">{{ $t('administration.clients.members.name_label') }}</th>
          <th scope="col">{{ $t('administration.clients.members.email_label') }}</th>
          <th scope="col">{{ $t('administration.clients.members.phone_label') }}</th>
          <th scope="col">{{ $t('administration.clients.members.role_label') }}</th>
          <th width="100"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="object in tableItems">
          <td>
            <router-link
                :to="{ name: 'administration.userView', params: { slug: object.slug }}"
                qid="client-members-name"
            >
              {{object.name}}
            </router-link>
          </td>
          <td>{{object.email}}</td>
          <td>{{object.phone}}</td>
          <td>
            <span v-for="role in object.userRoles">
              <span v-if="role.client === client.id">
                {{role.name}}
              </span>
            </span>
          </td>
          <td>
            <span class="text-muted cursor-pointer" qid="client-members-delete-button" @click="showConfirmDeleteModal(object)">
                <font-awesome-icon icon="trash-alt"/>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <b-pagination class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            @change="pageChanged"
    ></b-pagination>
    <span class="text-muted pagination-counter">
      {{ tableItems.length }} of {{ totalRows}}
    </span>


    <!-- Remove member from client confirm modal template -->
    <b-modal ref="remove-member" hide-footer>
      <div class="d-block text-center">
        <h4 qid="remove-member-title">
          {{ $t('administration.clients.members.delete_title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('administration.clients.members.delete_description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('administration.clients.members.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="remove-member-cancel-button"
        >
          {{ $t('administration.clients.members.delete_cancel') }}
        </b-button>
        <b-button @click="confirmRemoveMember(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="remove-member-submit-button"
        >
          {{ $t('administration.clients.members.delete_submit') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'ClientMembers',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('administration.title'),
            to: '/administration'
          },
          {
            text: this.$t('administration.clients.title'),
            to: '/administration/clients'
          }
        ],
        tableItems: [],
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        client: {},
        itemToDelete: {},
        error: '',
        // Needs to be set as an array (because of 3rd party component)
        selectedUser: [],
        selectedRole: [],
        options: [],
        roles: [],
        roleIsInvalid: false,
        userIsInvalid: false
      }
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      }
    },
    methods: {
      loadUsers(page) {
        this.asyncFind();
        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let self = this;
        piincHttp.get('clients/' + this.$route.params.slug + '/users', { params: {
            page: pageNumber
          }}).then(function(response) {
          self.tableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {
          // Error
        });
      },
      asyncFind (query) {
        this.isLoading = true
        let self = this;
        piincHttp.get('users', { params: {
            keyword: query,
            not_member_of_client: this.$route.params.slug
          }}).then(function(response) {
            self.options = response.data.items
            self.isLoading = false
        }, function() {});
      },
      addUser() {
        let self = this;
        // Only allow API call if selectedUser and selected roles are not empty arrays
        if (!Array.isArray(this.selectedUser)) {
          piincHttp.post('clients/' + this.$route.params.slug + '/users', {
            client: this.client.slug,
            user: this.selectedUser.slug,
            role: this.selectedRole? this.selectedRole.id: undefined
          }).then(function(response) {
            // Needs to be set to empty array in order to work
            self.selectedUser = [];
            self.selectedRole = [];
            self.userIsInvalid = false;
            self.roleIsInvalid = false;
            self.$toastr('success', self.$t('administration.clients.members.add_success'))
            self.loadUsers();
          }, function(error) {})
        } else {
          this.userIsInvalid = true;
          this.roleIsInvalid = true;
        }

      },
      pageChanged(page) {
        // Load clients when page changed listener is triggered
        this.loadUsers(page)
      },
      showConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['remove-member'].show()
      },
      hideConfirmDeleteModal() {
        this.itemToDelete = {};
        this.$refs['remove-member'].hide()
      },
      confirmRemoveMember(user) {
        let self = this;
        piincHttp.delete('clients/' + this.$route.params.slug + '/users/' + user.slug).then(function(response) {
          self.hideConfirmDeleteModal();
          self.loadUsers(self.currentPage);
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('administration.clients.members.delete_success'))
        }, function() {});
      },
    },
    components: {

    },
    created () {
      this.loadUsers();
      let self = this;

      piincHttp.get('clients/' + this.$route.params.slug).then(function(response) {
        self.client = response.data;
        if (self.client && self.client.parent) {
          _.forEach(response.data.clientRoles, function(role) {
            if (role.name != 'Client admin'){
              self.roles.push(role)
            }
          })
        } else {
          _.forEach(response.data.clientRoles, function(role) {
            if (role.name != 'Partition admin'){
              self.roles.push(role)
            }
          })
        }

        // Push clients name in breadcrumb array
        self.breadcrumbItems.push({text: self.client.name, to: {name: 'administration.clientView', params: {slug: self.client.slug}}});
        self.breadcrumbItems.push({text: self.$t('administration.clients.members.title'), active: true});
      }, function() {});
    }
  }
</script>
